import React, {PropsWithChildren} from 'react'
import Skeleton, {SkeletonTheme}from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

type Props = {
  circle?:boolean;
  inline?:boolean;
  width?:number | string;
  height?:number | string;
  count?:number;
  containerClassName?:string;
  baseColor?:string;
  highlightColor?:string;
  wrapper?:any;
  style?: React.CSSProperties;
}

function InlineWrapperWithMargin({ children }: PropsWithChildren<unknown>) {
  return <span style={{ marginRight: '0.5rem' }}>{children}</span>
}

export default function SkeletonLoading({width = 100, height = 20, circle = false, inline = true, containerClassName, count, baseColor, highlightColor, wrapper, ...args}:Props) {
    const totalwidth = width?width:circle?100:"";
    const totalheight = height?height:circle?100:"";
  return (
    <SkeletonTheme baseColor={baseColor?baseColor:"#f0fbfb"} highlightColor={highlightColor?highlightColor:"#66CFC8"}>
    <Skeleton
      circle={circle}
      inline={inline}
      wrapper={wrapper?wrapper:InlineWrapperWithMargin}
      width={totalwidth}
      height={totalheight}
      count={count}
      containerClassName={containerClassName}
      style={args.style}
      enableAnimation />
    </SkeletonTheme>
  )
}
